import { emptyObj } from 'util/objects'

export const selectRawById = state => state.tickets.byId || emptyObj
